module.exports = __webpack_public_path__ + "8504b3453e7d118892c961b84038683e.mp3";